import { render } from "./RiskLevel.vue?vue&type=template&id=75f6fc46"
import script from "./RiskLevel.vue?vue&type=script&lang=js"
export * from "./RiskLevel.vue?vue&type=script&lang=js"

import "./RiskLevel.vue?vue&type=style&index=0&id=75f6fc46&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__